import React, { useEffect, useState } from "react";
import Bookingdetails1 from "./Bookingsdetails1";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import formatDateAndTime from "../../common/formatDateAndTime";
import formatDate from "../../common/Formatdate";
import toast from "react-hot-toast";
import InfoIcon from "@mui/icons-material/Info";
import moment from "moment";
import { BlinkBlur } from "react-loading-indicators";
import UseOnlineStatus from "../../common/UseOnlineStatus";

const formatDateTime = (isoString) => {
  const [date, time] = isoString.split("T");
  return {
    date,
    time: time?.slice(0, 5) || "",
  };
};
const Swapvehicle = ({
  summaryDetails,
  vehicleDetails,
  paymentDetailsData,
  getBookingDetail,
  cities,
  getVehicleWappingDetails,
  transactionDetails,
}) => {
  const { isOnline, isSlowConnection } = UseOnlineStatus();
  const fuelType = JSON.parse(localStorage.getItem("catalogValues"))?.fuelType;
  const vehicleBodyType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBodyType;
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const paymentCollectionType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.paymentCollectionType;
  const profile = JSON.parse(localStorage.getItem("profile"));
  delete paymentCollectionType?.inverted;
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const [inputData, setInputData] = useState({
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });
  let bookingTypesDuplicate = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.bookingTypes;
  const [availableVehicles, setAvailableVehicels] = useState([]);
  const [affectedBookings, setAffectedBookings] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedVehicleType, setSelectedVehicleType] = useState("");
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [paymentSavedDetails, setPaymentSavedDetails] = useState(null);
  const [paymentLink, setPaymentLink] = useState(null);
  const [requestedBy, setRequestedBy] = useState(null);
  const [transactiondetails, settransactiodetails] = useState({
    transactionid: "",
    transactioncharges: "",
    paymentmode: "",
    payableamount: "",
    paymentremarks: "",
    attachments: null,
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [requestedByError, setRequestedByError] = useState("");
  const [selectedVehicleWithRent, setSelectedVehicleWithRent] = useState(null);
  const [selectedVehicleResponse, setSelectedVehicleResponse] = useState(null);
  const [paymentTypeErrors, setPaymentTypeErrors] = useState("");
  const [selectModal, setSelectModal] = useState(null);
  const [availableModal, setAvailableModal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentLinkGenerated, setPaymentLinkGenerated] = useState(false);
  const [selectedBookingTypeError, setSelectedBookingTypeError] = useState("");

  const hasUnstableConnection = !isOnline || isSlowConnection;

  console.log("selectedVehicleType", selectedVehicleType)

  let vehicleTypeCatalog = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleType;

  const showNetworkAlert = () => {
    setPaymentLinkGenerated(false);
    toast.error(
      "Please check your network connection. Your internet connection appears to be unstable.",
      {
        position: "bottom-center",
        style: {
          background: "white",
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      },
    );
  };

  const swapDetailsInput = [
    {
      label: "Requested By",
      type: "dropdown",
      isEnable: false,
      placeholder: "",
      value: "requestedby",
      subCategory: [
        { sublabel: "Admin", item: "Admin" },
        { sublabel: "Customer", item: "customer" },
      ],
    },
    {
      label: "Payment Collection Type ",
      type: "dropdown",
      isEnable: false,
      placeholder: "",
      value: "paymentcollectiontype",
      subCategory: Object.entries(paymentCollectionType).map(
        ([key, value]) => ({
          sublabel: value,
          item: key,
        }),
      ),
    },
    {
      label: "Reason For Swapping ",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "reasonforswapping",
      subCategory: [],
    },
  ];

  const getAvailableModal = async () => {
    try {
      const startDateTime = `${inputData.startDate}T${inputData.startTime}`;
      const endDateTime = `${inputData.endDate}T${inputData.endTime}`;

      const packageName = paymentDetailsData?.packageDetails?.name || "";

      let endpoint =
        summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
          summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
          summaryDetails?.packageSelectedKey === "dailyRateMonthly"
          ? "/api/subscriptionbookings/search-vehicle-swapping"
          : "/api/vehiclebookings/searchvehiclesforswapping";

      let query = "";

      if (startDateTime) {
        query += `startDate=${startDateTime}`;
      }

      if (endDateTime) {
        query += `&endDate=${endDateTime}`;
      }

      if (packageName) {
        query += `&freeKmValue=${packageName}`;
      }

      if (
        summaryDetails?.cityId ||
        summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
        summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
        summaryDetails?.packageSelectedKey === "dailyRateMonthly"
      ) {
        query += `&cityId=${summaryDetails.cityId}`;
      }

      if (
        summaryDetails?.hubId ||
        summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
        summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
        summaryDetails?.packageSelectedKey === "dailyRateMonthly"
      ) {
        query += `&hubId=${summaryDetails.cityId}`;
      }

      const discountPercentage =
        requestedBy === "Admin" ? summaryDetails?.discountPercentage : 0;

      if (
        discountPercentage !== undefined &&
        discountPercentage !== null &&
        (summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
          summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
          summaryDetails?.packageSelectedKey === "dailyRateMonthly")
      ) {
        query += `&discountPercentage=${discountPercentage}`;
      }

      const response = await fetch(`${apiUrl}${endpoint}?${query}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100" && data?.dataValues.length) {
        let filter = []
        if (String(selectedVehicleType) === String(vehicleTypeCatalog?.inverted?.car)) {
          filter = data?.dataValues.filter((item) => String(item?.vehicleType) === String(vehicleTypeCatalog?.inverted?.car))
        } else if (String(selectedVehicleType) === String(vehicleTypeCatalog?.inverted?.electricCar)) {
          filter = data?.dataValues.filter((item) => String(item?.vehicleType) === String(vehicleTypeCatalog?.inverted?.electricCar))
        } else if (String(selectedVehicleType) === String(vehicleTypeCatalog?.inverted?.bike)) {
          filter = data?.dataValues.filter((item) => String(item?.vehicleType) === String(vehicleTypeCatalog?.inverted?.bike))
        } else {
          filter = data?.dataValues
        }
        // console.log("Filter", filter)
        setAvailableModal(filter);
        setSelectedVehicle(null);
      } else {
        toast.error("No Vehicle Modals are available");
      }
      return data;
    } catch (error) {
      console.error("Error fetching Available Vehicles:", error);
    }
  };

  const today = new Date();
  const todayDateStr = today.toISOString().split("T")[0]; // yyyy-mm-dd
  const currentTimeStr = today.toTimeString().slice(0, 5); // HH:mm

  const getMinTime = (date) => {
    return date === todayDateStr ? currentTimeStr : undefined;
  };

  const generatepaymentlink = async (type) => {
    if (hasUnstableConnection) {
      showNetworkAlert();
      return;
    }

    setPaymentLinkGenerated(true);
    let payload;

    if (type === "generate") {
      payload = {
        bookingId: summaryDetails?.bookingId,
        amount: Math.round(selectedVehicleResponse.pendingAmount * 100),
        customerName: summaryDetails?.customerName,
        contactEmail: summaryDetails?.customerEmail,
        customerContact: summaryDetails?.customerMobile,
        customerId: summaryDetails?.customerId,
      };
    } else {
      payload = {
        paymentId: paymentLink?.paymentId,
        id: paymentLink?.id,
        bookingId: summaryDetails?.id,
        inquiryCode: summaryDetails?.inquiryCode,
      };
    }

    toast.loading("Processing... Please wait", {
      id: "initiateTransaction", // same ID to update later
      position: "bottom-center",
    });

    try {
      const response = await fetch(`${apiUrl}/api/paymentlinks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      toast.dismiss("initiateTransaction");
      if (data?.statusCode === "0100") {
        setPaymentLinkGenerated(false);
        if (data?.dataValues?.status === "created") {
          toast.success("Payment link generated successfully.");
        } else {
          toast.success("Payment Captured successfully.");
          // getBookingDetail(summaryDetails?.inquiryCode, "inquiry");
        }
        setPaymentLink(data?.dataValues);
      } else {
        setPaymentLinkGenerated(false);
        toast.error(data?.msg, {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      }
      return data;
    } catch (error) {
      return;
      setPaymentLinkGenerated(false);
      toast.dismiss("initiateTransaction");
      console.error("Error fetching Affected Bookings:", error);
    }
  };

  function formatDateTimeNew(isoString) {
    const m = moment(isoString);

    return {
      date: m.format("YYYY-MM-DD"), // <-- required for input[type=date]
      time: m.format("HH:mm"), // <-- required for input[type=time]
    };
  }

  useEffect(() => {
    if (summaryDetails?.bookFrom && summaryDetails?.bookTo) {
      const start = formatDateTimeNew(summaryDetails.bookFrom);
      const end = formatDateTimeNew(summaryDetails.bookTo);

      setInputData({
        startDate: start.date,
        startTime: start.time,
        endDate: end.date,
        endTime: end.time,
      });
    }
  }, [summaryDetails]);

  const swappingDetailsInput = [
    {
      label: "Start Date",
      type: "date",
      isEnable: true,
      placeholder: "",
      value: "startDate",
      min: todayDateStr,
    },
    {
      label: "Start Time",
      type: "time",
      isEnable: true,
      placeholder: "",
      value: "startTime",
      min: getMinTime(inputData.startDate),
    },
    {
      label: "End Date",
      type: "date",
      isEnable: true,
      placeholder: "",
      value: "endDate",
      min: todayDateStr,
    },
    {
      label: "End Time",
      type: "time",
      isEnable: true,
      placeholder: "",
      value: "endTime",
      min: getMinTime(inputData.startDate),
    },
  ];

  const transactionDetailsInput = [
    {
      label: "Transaction Id",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "transactionid",
    },
    {
      label: "Transaction Charges",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "transactioncharges",
    },
    {
      label: "Payment Mode",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "paymentmode",
    },
    {
      label: "Payable Amount",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "payableamount",
    },
    {
      label: "Payment Remarks",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "paymentremarks",
    },
    {
      label: "Attachments",
      type: "file",
      isEnable: false,
      placeholder: "",
      value: "attachments",
    },
  ];

  useEffect(() => {
    if (selectedVehicle) {
      getAffectedBookings();
    }
  }, [selectedVehicle]);

  const getAffectedBookings = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookings/getbookingbydates?startDate=${inputData?.startDate + "T" + inputData?.startTime
        }&endDate=${inputData?.endDate + "T" + inputData?.endTime}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();

      if (data?.statusCode === "0100") {
        const filtered = data?.dataValues?.filter(
          (item) => String(item.vehicleId) === String(selectedVehicle?.id),
        );

        setAffectedBookings(filtered);
      }
      return data;
    } catch (error) {
      console.error("Error fetching Affected Bookings:", error);
    }
  };

  const getAvailableVehicle = async (id) => {
    const startDateTime = `${inputData.startDate}T${inputData.startTime}`;
    const endDateTime = `${inputData.endDate}T${inputData.endTime}`;

    let endpoint =
      summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
        summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
        summaryDetails?.packageSelectedKey === "dailyRateMonthly"
        ? "/api/subscriptionbookings/search-vehicle-by-group-date"
        : "/api/availablevehicle/search";

    try {
      const response = await fetch(
        `${apiUrl}${endpoint}?startDate=${startDateTime}&endDate=${endDateTime}&groupId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100" && data?.dataValues.length) {
        setAvailableVehicels(data?.dataValues);
      } else {
        toast.error("No Vehicles available for this model");
      }
      return data;
    } catch (error) {
      return console.error(
        "Error fetching get available vehicle for initiate booking:",
        error,
      );
    }
  };

  useEffect(() => {
    if (selectModal?.vehicleGroupId) {
      getAvailableVehicle(selectModal?.vehicleGroupId);
    }
  }, [selectModal]);

  const handleSave = async () => {
    if (hasUnstableConnection) {
      showNetworkAlert();
      return;
    }

    let isValid = true;
    const newErrors = {};

    // Required fields
    const requiredFields = [
      "transactionid",
      "transactioncharges",
      "paymentmode",
      "payableamount",
      "paymentremarks",
      "attachments",
    ];

    requiredFields.forEach((field) => {
      if (!transactiondetails[field]) {
        newErrors[field] = "* Required";
        isValid = false;
      } else {
        const valid = validateField(field, transactiondetails[field]);
        if (!valid) isValid = false;
      }
    });

    setErrors(newErrors);

    if (!isValid) {
      toast.error("Please fix errors before submitting payment details");
      return;
    }

    toast.loading("Processing... Please wait", {
      id: "transaction", // same ID to update later
      position: "bottom-center",
    });

    try {
      const response = await fetch(`${apiUrl}/api/bookingtransactions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          amount: transactiondetails?.payableamount,
          paymentMode: transactiondetails?.paymentmode,
          transactionCode: transactiondetails?.transactionid,
          transactionalCharges: transactiondetails?.transactioncharges,
          bookingId: summaryDetails?.id,
          description: transactiondetails?.paymentremarks,
          attachments: transactiondetails?.attachments
            ? JSON.stringify(transactiondetails.attachments)
            : null,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.dismiss("transaction");
        toast.success(
          "Payment details added successfully. Click update booking to confirm the process.",
          {
            position: "bottom-center",
            style: {
              background: "blue", // override background
              color: "white",
              fontWeight: "medium",
              marginBottom: "20px",
            },
          },
        );
        settransactiodetails({
          transactionid: "",
          transactioncharges: "",
          paymentmode: "",
          payableamount: "",
          paymentremarks: "",
        });
        setPaymentSavedDetails(data?.dataValues);
      }
      return data;
    } catch (error) {
      return console.error(
        "Error fetching POST booking transaction initiate booking:",
        error,
      );
    }
  };

  const validateField = (key, value) => {
    let errorMsg = "";

    if (key === "transactioncharges" && !/^\d+$/.test(value)) {
      errorMsg = "* Accepts only numbers";
    }
    if (key === "payableamount" && !/^\d+(\.\d{1,2})?$/.test(value)) {
      errorMsg = "* Accepts only numbers (up to 2 decimals)";
    }
    if (key === "documentype" && !value) {
      errorMsg = "Please select a document type";
    }
    if (key === "paymentmode" && !/^[a-zA-Z ]*$/.test(value)) {
      errorMsg = "* Accepts only alphabets";
    }
    if (key === "attachments" && !value) {
      errorMsg = "* Attachment required";
    }

    setErrors((prev) => ({ ...prev, [key]: errorMsg }));
    return errorMsg === "";
  };

  function formatDateforApi(dateString) {
    const date = new Date(dateString);
    return date.toISOString().slice(0, 16);
  }

  const updateBooking = async () => {
    const oldStartDate = formatDateforApi(summaryDetails?.bookFrom);
    const oldEndDate = formatDateforApi(summaryDetails?.bookTo);

    toast.loading("Processing... Please wait", {
      id: "swap", // same ID to update later
      position: "bottom-center",
    });

    let payload;

    if (selectedPaymentType === "Post Paid") {
      payload = {
        modifiedBy: profile?.id,
        bookingId: summaryDetails?.id,
        bookingCode: summaryDetails?.bookingCode,
        previousVehicleId: summaryDetails?.vehicleId,
        previousVehicleRegistrationNo: summaryDetails?.vehicleRegistrationNo,
        previousVehicleName: summaryDetails?.vehicleName,
        vehicleId: selectedVehicle?.id,
        vehicleRegistrationNo: selectedVehicle?.licensePlate,
        vehicleName: selectedVehicle?.name,
        reasonForSwapping: "",
        requestedBy: requestedBy,
        previousRent: summaryDetails?.costToCustomer,
        newRent:
          selectedVehicleResponse?.selectedVehicleWithRent.costToTheCustomer,
        paymentType: selectedPaymentType,
        previousPackageId: paymentDetailsData?.packageDetails?.id,
        previousPackageName: paymentDetailsData?.packageDetails?.name,
        newPackageId: selectModal?.packageId,

        bookingObj: {
          vehicleId: selectedVehicle?.id,
          vehicleName: selectedVehicle?.name,
          vehicleRegistrationNo: selectedVehicle?.licensePlate,
          vehicleGroupId: selectedVehicle?.vehicleGroupId,
          packageId: selectModal?.packageId,
          id: summaryDetails?.id,
          bookingCode: summaryDetails?.bookingCode,
          weekdayRent: selectModal?.weekdayRent,
          weekendRent: selectModal?.weekendRent,
          securityDeposit: selectModal?.securityDeposit,
          weekdayHrs: selectModal?.weekdayHrs,
          weekendHrs: selectModal?.weekendHrs,

          overallFreeKm: selectModal?.totalFreeKms,
          discountAmount: selectModal?.totalDiscount,

          taxAmount: selectModal?.taxAmount,
          id: summaryDetails?.id,
          costToCustomer:
            selectedVehicleResponse?.selectedVehicleWithRent?.costToTheCustomer,

          vehicleType: selectedVehicle?.vehicleType,
          bookingType: selectedVehicleType === vehicleTypeCatalog?.inverted?.car ? bookingTypesDuplicate?.inverted?.dailyRental : selectedVehicleType === vehicleTypeCatalog?.inverted?.electricCar ? bookingTypesDuplicate?.inverted?.electricCars : summaryDetails?.bookingType,
        },
        tempBookingObject: {
          vehicleId: selectedVehicle?.id,
        },
      };
    } else if (selectedPaymentType === "Pre Paid") {
      payload = {
        modifiedBy: profile?.id,
        bookingId: summaryDetails?.id,
        bookingCode: summaryDetails?.bookingCode,
        previousVehicleId: summaryDetails?.vehicleId,
        previousVehicleRegistrationNo: summaryDetails?.vehicleRegistrationNo,
        previousVehicleName: summaryDetails?.vehicleName,
        vehicleId: selectedVehicle?.id,
        vehicleRegistrationNo: selectedVehicle?.licensePlate,
        vehicleName: selectedVehicle?.name,
        reasonForSwapping: "",
        requestedBy: requestedBy,
        previousRent: summaryDetails?.costToCustomer,
        newRent:
          selectedVehicleResponse?.selectedVehicleWithRent?.costToTheCustomer,
        paymentType: selectedPaymentType,
        previousPackageId: paymentDetailsData?.packageDetails?.id,
        previousPackageName: paymentDetailsData?.packageDetails?.name,
        newPackageId: selectModal?.packageId,
        bookingObj: {
          vehicleId: selectedVehicle?.id,
          vehicleName: selectedVehicle?.name,
          vehicleRegistrationNo: selectedVehicle?.licensePlate,
          vehicleGroupId: selectedVehicle?.vehicleGroupId,
          packageId: selectModal?.packageId,
          id: summaryDetails?.id,
          bookingCode: summaryDetails?.bookingCode,
          weekdayRent: selectModal?.weekdayRent,
          weekendRent: selectModal?.weekendRent,
          securityDeposit: selectModal?.securityDeposit,
          weekdayHrs: selectModal?.weekdayHrs,
          weekendHrs: selectModal?.weekendHrs,
          overallFreeKm: selectModal?.totalFreeKms,
          discountAmount: selectModal?.totalDiscount,
          taxAmount: selectModal?.taxAmount,
          id: summaryDetails?.id,
          costToCustomer:
            selectedVehicleResponse?.selectedVehicleWithRent?.costToTheCustomer,

          vehicleType: selectedVehicle?.vehicleType,
          bookingType: selectedVehicleType === vehicleTypeCatalog?.inverted?.car ? bookingTypesDuplicate?.inverted?.dailyRental : selectedVehicleType === vehicleTypeCatalog?.inverted?.electricCar ? bookingTypesDuplicate?.inverted?.electricCars : summaryDetails?.bookingType,
        },
        tempBookingObject: {
          vehicleId: selectedVehicle?.id,
        },
      };
    } else if (selectedPaymentType === "With Refund") {
      payload = {
        modifiedBy: profile?.id,
        bookingId: summaryDetails?.id,
        bookingCode: summaryDetails?.bookingCode,
        previousVehicleId: summaryDetails?.vehicleId,
        previousVehicleRegistrationNo: summaryDetails?.vehicleRegistrationNo,
        previousVehicleName: summaryDetails?.vehicleName,
        vehicleId: selectedVehicle?.id,
        vehicleRegistrationNo: selectedVehicle?.licensePlate,
        vehicleName: selectedVehicle?.name,
        reasonForSwapping: "",
        requestedBy: requestedBy,
        previousRent: summaryDetails?.costToCustomer,
        newRent:
          selectedVehicleResponse?.selectedVehicleWithRent?.costToTheCustomer,
        paymentType: selectedPaymentType,
        previousPackageId: paymentDetailsData?.packageDetails?.id,
        previousPackageName: paymentDetailsData?.packageDetails?.name,
        newPackageId: selectModal?.packageId,
        bookingObj: {
          vehicleId: selectedVehicle?.id,
          vehicleName: selectedVehicle?.name,
          vehicleRegistrationNo: selectedVehicle?.licensePlate,
          vehicleGroupId: selectedVehicle?.vehicleGroupId,
          packageId: selectModal?.packageId,
          id: summaryDetails?.id,
          bookingCode: summaryDetails?.bookingCode,
          weekdayRent: selectModal?.weekdayRent,
          weekendRent: selectModal?.weekendRent,
          securityDeposit: selectModal?.securityDeposit,
          weekdayHrs: selectModal?.weekdayHrs,
          weekendHrs: selectModal?.weekendHrs,
          overallFreeKm: selectModal?.totalFreeKms,
          discountAmount: selectModal?.totalDiscount,
          taxAmount: selectModal?.taxAmount,
          id: summaryDetails?.id,
          costToCustomer: Math.abs(
            selectedVehicleResponse?.selectedVehicleWithRent?.costToTheCustomer,
          ),

          vehicleType: selectedVehicle?.vehicleType,
          bookingType: selectedVehicleType === vehicleTypeCatalog?.inverted?.car ? bookingTypesDuplicate?.inverted?.dailyRental : selectedVehicleType === vehicleTypeCatalog?.inverted?.electricCar ? bookingTypesDuplicate?.inverted?.electricCars : summaryDetails?.bookingType,
        },
        tempBookingObject: {
          vehicleId: selectedVehicle?.id,
        },
      };
    } else if (selectedPaymentType === "Freeze") {
      payload = {
        modifiedBy: profile?.id,
        bookingId: summaryDetails?.id,
        bookingCode: summaryDetails?.bookingCode,
        previousVehicleId: summaryDetails?.vehicleId,
        previousVehicleRegistrationNo: summaryDetails?.vehicleRegistrationNo,
        previousVehicleName: summaryDetails?.vehicleName,
        vehicleId: selectedVehicle?.id,
        vehicleRegistrationNo: selectedVehicle?.licensePlate,
        vehicleName: selectedVehicle?.name,
        reasonForSwapping: "",
        requestedBy: requestedBy,
        previousRent: summaryDetails?.costToCustomer,
        newRent:
          selectedVehicleResponse?.selectedVehicleWithRent?.costToTheCustomer,
        paymentType: selectedPaymentType,
        previousPackageId: paymentDetailsData?.packageDetails?.id,
        previousPackageName: paymentDetailsData?.packageDetails?.name,
        newPackageId: selectModal?.packageId,
        bookingObj: {
          vehicleId: selectedVehicle?.id,
          vehicleName: selectedVehicle?.name,
          vehicleRegistrationNo: selectedVehicle?.licensePlate,
          vehicleGroupId: selectedVehicle?.vehicleGroupId,
          packageId: selectModal?.packageId,
          id: summaryDetails?.id,
          bookingCode: summaryDetails?.bookingCode,
          vehicleType: selectedVehicle?.vehicleType,
          bookingType: selectedVehicleType === vehicleTypeCatalog?.inverted?.car ? bookingTypesDuplicate?.inverted?.dailyRental : selectedVehicleType === vehicleTypeCatalog?.inverted?.electricCar ? bookingTypesDuplicate?.inverted?.electricCars : summaryDetails?.bookingType,
        },
        tempBookingObject: {
          vehicleId: selectedVehicle?.id,
        },
      };
    }

    console.log("payload", payload)
    // return

    try {
      const response = await fetch(`${apiUrl}/api/fleetbookingswappings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.dismiss("swap");
        toast.success("Swapping Vehicle details Updated.");
        // setPaymentSavedDetails(data?.dataValues);
        getBookingDetail(summaryDetails?.inquiryCode, "inquiry");
        getVehicleWappingDetails(summaryDetails?.id);
        // setActiveTab('trip')
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error(
        "Error fetching POST booking transaction initiate booking:",
        error,
      );
    }
  };

  useEffect(() => {
    if (selectedVehicle) {
      setSelectedVehicleWithRent(
        availableModal.find((item) => {
          return item?.vehicleGroupId === selectModal?.vehicleGroupId;
        }),
      );
    }
  }, [selectedVehicle]);

  useEffect(() => {
    if (selectedVehicleWithRent) {
      getTheSelectedVehicleRent();
    }
  }, [selectedVehicleWithRent]);

  // useEffect(() => {
  //   if (summaryDetails?.costToCustomer) {
  //     settransactiodetails((prev) => ({
  //       ...prev,
  //       payableamount: summaryDetails?.costToCustomer,
  //     }));
  //   }
  // }, [summaryDetails]);

  const getTheSelectedVehicleRent = async () => {
    setLoading(true);
    const totalPaid = transactionDetails.reduce(
      (sum, txn) => sum + (txn.amount || 0),
      0,
    );

    try {
      const response = await fetch(
        `${apiUrl}/api/fleetbookingswappings/calculatependingamount`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            selectedVehicleWithRent: {
              securityDeposit: selectedVehicleWithRent?.securityDeposit,
              extraKmRental: selectedVehicleWithRent?.extraKmRental,
              discountPercentage:
                requestedBy === "Admin"
                  ? Number(selectedVehicleWithRent?.discountPercentage)
                  : 0,
              taxAmount: selectedVehicleWithRent?.taxAmount,
              totalDiscount:
                requestedBy === "Admin"
                  ? selectedVehicleWithRent?.totalDiscount
                  : 0,
              totalRent: selectedVehicleWithRent?.totalRent,
              weekdayRent: selectedVehicleWithRent?.weekdayRent,
              weekendRent: selectedVehicleWithRent?.weekendRent,
              baseFare: selectedVehicleWithRent?.baseFare,
              costToTheCustomer: selectedVehicleWithRent?.costToTheCustomer,
              deliveryCharges: paymentDetailsData?.deliveryCharges,
              pickupCharges: paymentDetailsData?.pickupCharges,
            },
            bookingInfo: {
              costToCustomer: paymentDetailsData?.costToCustomer,
              weekdayRent: summaryDetails?.weekdayRent,
              weekendRent: summaryDetails?.weekendRent,
              bookingHrs: summaryDetails?.bookingHrs,
              deliveryCharges: paymentDetailsData?.deliveryCharges,
              pickupCharges: paymentDetailsData?.pickupCharges,
              taxAmount: summaryDetails?.taxAmount,
              discountAmount: summaryDetails?.discountAmount,
              discountPercentage: Number(summaryDetails?.discountPercentage),
              securityDeposit: summaryDetails?.securityDeposit,
            },
            totalAmountPaid: totalPaid,
          }),
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setSelectedVehicleResponse(data?.entities);
      }

      return data;
    } catch (error) {
      return console.error(
        "Error fetching POST booking transaction initiate booking:",
        error,
      );
    }
  };

  const handleInputChange = async (key, event) => {
    let value;

    if (event?.target?.type === "file") {
      value = event.target.files[0];

      if (value) {
        const formData = new FormData();
        formData.append("entityName", "booking");
        formData.append("fileTags", "vehicle");
        formData.append("files", value);

        try {
          const response = await fetch(`${apiUrl}/fileapi/upload`, {
            method: "POST",
            body: formData,
          });
          const data = await response.json();
          if (data) {
            toast.success("Image Uploaded successfully.", {
              position: "bottom-center",
              style: {
                background: "blue", // override background
                color: "white",
                fontWeight: "medium",
                marginBottom: "20px",
              },
            });
            setSelectedFile(data?.uploaded);
            settransactiodetails((prev) => ({
              ...prev,
              attachments: data?.uploaded,
            }));
            validateField("attachments", data?.uploaded);
          }
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    } else {
      value = event?.target?.value !== undefined ? event.target.value : event;

      settransactiodetails((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
    validateField(key, value);
  };

  useEffect(() => {
    if (selectedVehicleResponse?.pendingAmount) {
      settransactiodetails((prev) => ({
        ...prev,
        payableamount: selectedVehicleResponse?.pendingAmount,
      }));
    }
  }, [selectedVehicleResponse]);

  return (
    <div className="md:p-6">
      <div className="flex items-start justify-between gap-6 mb-8">
        <div>
          <h2 className="text-2xl font-semibold text-[#2c3e50]">
            Vehicle Swapping Process
          </h2>

          <p className="mt-1 text-sm text-gray-500">
            Review the booking details before proceeding with the swapping.
          </p>
        </div>

        {(summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
          summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
          summaryDetails?.packageSelectedKey === "dailyRateMonthly") && (
            <div className="flex items-start gap-3 max-w-md px-4 py-3 rounded-xl bg-orange-50 border border-orange-200 shadow-sm">
              <div className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-lg bg-orange-100">
                <span className="text-orange-600 text-sm">📝</span>
              </div>

              <div>
                <p className="mt-1 text-xs leading-5 text-orange-700">
                  Note: This booking is for a subscription.
                </p>
              </div>
            </div>
          )}
      </div>
      {/* <Bookingdetails1
        paymentDetailsData={paymentDetailsData}
        vehicleDetails={vehicleDetails}
        summaryDetails={summaryDetails}
        cities={cities}
      /> */}
      <div className="md:px-4 py-6 bg-white shadow-md rounded-lg">
        {/* <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center gap-2 border-b pb-2">
          Swapping vehicle
        </h2> */}

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {swappingDetailsInput.map((item, index) => (
            <div key={index} className="flex flex-col">
              <label
                htmlFor={item?.value}
                className="text-gray-700 font-medium mb-2"
              >
                {item?.label}
              </label>

              <input
                id={item.value}
                name={item.value}
                type={item.type}
                value={inputData[item.value] || ""}
                onChange={(e) =>
                  setInputData((prev) => ({
                    ...prev,
                    [item.value]: e.target.value,
                  }))
                }
                disabled={item?.isEnable}
                min={item.min}
                className="border border-gray-300 rounded-md px-4 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 disabled:bg-gray-100 disabled:text-gray-500"
              />
            </div>
          ))}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-3 gap-4">
        <div>
          <label>
            Requested By{" "}
            <select
              onChange={(e) => {
                setRequestedBy(e.target.value);
                setRequestedByError(""); // clear error when user selects
                setSelectedBookingTypeError(""); // clear booking type error
                setSelectedVehicle(null);
                setSelectedVehicleResponse(null);
                setSelectedVehicleWithRent(null);
                setAvailableVehicels([]);
                setSelectModal(null);
                setAvailableModal([]);
              }}
              className="w-full h-12 mt-4 p-3 border border-gray-300 rounded-md"
              value={requestedBy || ""}
            >
              <option value="">Select</option>
              <option value="Admin">Admin</option>
              <option value="Customer">Customer</option>
            </select>
          </label>
          {requestedByError && (
            <p className="text-red-500 text-sm mt-1">{requestedByError}</p>
          )}
        </div>
        {!(summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
          summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
          summaryDetails?.packageSelectedKey === "dailyRateMonthly") && <div>
            <label>
              Convert To Vehicle Type{" "}
              <select
                onChange={(e) => {
                  setSelectedVehicleType(e.target.value);
                  setSelectedBookingTypeError("");
                }}
                className="w-full h-12 mt-4 p-3 border border-gray-300 rounded-md"
                value={selectedVehicleType}
              >
                <option value="">Select</option>
                <option value={vehicleTypeCatalog?.inverted?.car ?? ""}>
                  Normal Car
                </option>
                <option value={vehicleTypeCatalog?.inverted?.electricCar ?? ""}>
                  EV Car
                </option>
              </select>
            </label>
            {selectedBookingTypeError && (
              <p className="text-red-500 text-sm mt-1">{selectedBookingTypeError}</p>
            )}
          </div>}
        <div className="flex justify-end mt-8 px-4">
          <button
            onClick={() => {
              if (!requestedBy) {
                setRequestedByError("* Please select Requested By");
                return;
              }
              if (!selectedVehicleType && !(summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
                summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
                summaryDetails?.packageSelectedKey === "dailyRateMonthly")) {
                setSelectedBookingTypeError("* Please select Vehicle Type");
                return;
              }
              getAvailableModal(); // call function
            }}
            className="w-52 h-12 rounded-[3em] flex justify-center items-center gap-3 cursor-pointer bg-[#4966f5] transition-all duration-[450ms] ease-in-out hover:bg-gradient-to-t hover:from-[#A47CF3] hover:to-[#683FEA] hover:shadow-[inset_0px_1px_0px_0px_rgba(20,20,20,0.4),inset_0px_-4px_0px_0px_rgba(0,0,0,0.2),0px_0px_0px_4px_rgba(20,20,20,0.2),0px_0px_180px_0px_#9917FF] hover:-translate-y-0.5 group"
          >
            {/* <svg
            height="24"
            width="24"
            viewBox="0 0 24 24"
            className="fill-[#AAAAAA] transition-all duration-[800ms] ease group-hover:fill-white group-hover:scale-110"
          >
            <path d="M10,21.236,6.755,14.745.264,11.5,6.755,8.255,10,1.764l3.245,6.491L19.736,11.5l-6.491,3.245ZM18,21l1.5,3L21,21l3-1.5L21,18l-1.5-3L18,18l-3,1.5ZM19.333,4.667,20.5,7l1.167-2.333L24,3.5,21.667,2.333,20.5,0,19.333,2.333,17,3.5Z" />
          </svg> */}
            <span className="font-semibold text-white text-base group-hover:text-white">
              Fetch Available Vehicle
            </span>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-8 p-4">
        {availableModal.length > 0 && (
          <div className="">
            <label>
              Select Modal{" "}
              <select
                id="availablevehicles"
                required
                onChange={(e) => {
                  setAvailableVehicels([]);
                  setSelectedVehicle(null);
                  setSelectModal(JSON.parse(e.target.value));
                }}
                className="w-full border-2 mt-4 border-gray-200 rounded-lg p-3 focus:ring focus:ring-blue-100"
              >
                <option value="">Select Modal</option>
                {availableModal.length > 0 &&
                  availableModal?.map((item, index) => {
                    return (
                      <option key={index} value={JSON.stringify(item)}>
                        {item?.name +
                          "-" +
                          // item?.registrationNo +
                          // "-" +
                          item?.fuelTypeText +
                          "-" +
                          item?.bodyTypeText +
                          "-" +
                          item?.seater +
                          " Seater"}
                      </option>
                    );
                  })}
              </select>
            </label>
          </div>
        )}

        {selectModal && (
          <div className="">
            <label>
              Select Vehicle{" "}
              <select
                id="availablevehicles"
                required
                onChange={(e) => {
                  getTheSelectedVehicleRent();
                  setSelectedVehicle(JSON.parse(e.target.value));
                }}
                className="w-full border-2 mt-4 border-gray-200 rounded-lg p-3 focus:ring focus:ring-blue-100"
              >
                <option value="">Select Vehicle</option>
                {availableVehicles.length > 0 &&
                  availableVehicles?.map((item, index) => {
                    return (
                      <option key={index} value={JSON.stringify(item)}>
                        {item?.name +
                          "-" +
                          item?.licensePlate +
                          "-" +
                          fuelType[item?.fuelType] +
                          "-" +
                          vehicleBodyType[item?.vehicleBodyType] +
                          "-" +
                          item?.seater +
                          " Seater"}
                      </option>
                    );
                  })}
              </select>
            </label>
          </div>
        )}
      </div>

      {selectedVehicle && (
        <div className="px-4">
          <h1 className="text-xl font-medium p-2 my-4 text-start">
            Affected Bookings
          </h1>
          <table className="min-w-full text-sm text-left shadow-xl rounded-lg border border-gray-300">
            <thead className="border-b pb-2 border-gray-500">
              <tr>
                <th className="p-4">Id</th>
                <th className="p-4">Booking Code</th>
                <th className="p-4">Book From</th>
                <th className="p-4">Book To</th>
                <th className="p-4">Status</th>
                <th className="p-4">Ticket Size</th>
              </tr>
            </thead>
            <tbody>
              {affectedBookings?.length > 0 ? (
                affectedBookings.map((data) => (
                  <tr key={data?.id} className="border-b hover:bg-gray-50">
                    <td className="p-4">{data?.id}</td>
                    <td className="p-4">{data?.bookingCode}</td>
                    <td className="p-4">{formatDateAndTime(data?.bookFrom)}</td>
                    <td className="p-4">{formatDateAndTime(data?.bookTo)}</td>
                    <td className="p-4">
                      {fleetBookingStatus[data?.bookingStatus]}
                    </td>
                    <td className="p-4 text-right">
                      {"₹ " + data?.costToCustomer}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center p-4 text-gray-500">
                    No affected bookings found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="p-6 mt-6 bg-gradient-to-br from-green-50 to-green-100 shadow-xl rounded-2xl">
            {loading ? (
              <>
                <div className="flex justify-center items-center mt-6">
                  <BlinkBlur size={40} color="#3b82f6" />
                </div>
              </>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {[
                  {
                    name: "Start Date",
                    value: formatDateAndTime(summaryDetails?.bookFrom),
                  },
                  {
                    name: "End Date",
                    value: formatDateAndTime(summaryDetails?.bookTo),
                  },
                  { name: "Vehicle Name", value: selectedVehicle?.name },
                  {
                    name: "Vehicle Registration",
                    value: selectedVehicle?.licensePlate,
                  },
                  {
                    name: "Weekday Hrs",
                    value: selectModal?.weekdayHrs
                      ? `${selectModal?.weekdayHrs} hrs`
                      : `${0} hrs`,
                  },
                  {
                    name: "Weekday Rent",
                    value: selectedVehicleResponse?.selectedVehicleWithRent
                      ?.weekdayRent
                      ? `₹ ${selectedVehicleResponse?.selectedVehicleWithRent.weekdayRent}`
                      : "-",
                  },
                  {
                    name: "Weekend Hrs",
                    value: selectModal?.weekendHrs
                      ? `${selectModal?.weekendHrs} hrs`
                      : `${0} hrs`,
                  },
                  {
                    name: "Weekend Rent",
                    value: selectedVehicleResponse?.selectedVehicleWithRent
                      ?.weekendRent
                      ? `₹ ${selectedVehicleResponse?.selectedVehicleWithRent.weekendRent}`
                      : "-",
                  },
                  {
                    name: "Total Hrs",
                    value: summaryDetails?.bookingHrs
                      ? `${summaryDetails.bookingHrs} hrs`
                      : "-",
                  },
                  {
                    name: "Total Free Km",
                    value: summaryDetails?.overallFreeKm
                      ? `${summaryDetails.overallFreeKm} Kms`
                      : "-",
                  },
                  {
                    name: "Base Fare",
                    value: selectedVehicleResponse?.selectedVehicleWithRent
                      ?.baseFare
                      ? `₹ ${selectedVehicleResponse?.selectedVehicleWithRent.baseFare}`
                      : "-",
                  },
                  requestedBy === "Admin" && {
                    name: "Discount %",
                    value: summaryDetails?.discountPercentage || "-",
                  },
                  requestedBy === "Admin" && {
                    name: "Discount Amount",
                    value: selectModal?.totalDiscount
                      ? `₹ ${Number(selectModal.totalDiscount.toFixed(2))}`
                      : "-",
                  },
                  {
                    name: "Tax Amount",
                    value: selectedVehicleResponse?.selectedVehicleWithRent
                      ?.taxAmount
                      ? `₹ ${selectedVehicleResponse?.selectedVehicleWithRent.taxAmount}`
                      : 0,
                  },
                  {
                    name: "Delivery Charges",
                    value: summaryDetails?.deliveryCharges
                      ? `₹ ${summaryDetails.deliveryCharges}`
                      : 0,
                  },
                  {
                    name: "Pickup Charges",
                    value: summaryDetails?.pickupCharges
                      ? `₹ ${summaryDetails.pickupCharges}`
                      : 0,
                  },
                  {
                    name: "Security Deposit",
                    value: selectModal?.securityDeposit
                      ? `₹ ${selectModal.securityDeposit}`
                      : "-",
                  },
                  {
                    name: "Previous Rent",
                    value: summaryDetails?.costToCustomer
                      ? `₹ ${Number(summaryDetails.costToCustomer.toFixed(2))}`
                      : "-",
                  },
                  {
                    name: "Previous Pending Rent",
                    value: paymentDetailsData?.pendingAmount
                      ? `₹ ${Number(
                        paymentDetailsData.pendingAmount.toFixed(2),
                      )}`
                      : "-",
                  },
                  {
                    name: "New Rent",
                    value: selectedVehicleResponse?.selectedVehicleWithRent
                      ?.costToTheCustomer
                      ? `₹ ${selectedVehicleResponse?.selectedVehicleWithRent?.costToTheCustomer}`
                      : "-",
                  },
                  {
                    name: "Payable Amount",
                    value: selectedVehicleResponse?.pendingAmount
                      ? `₹ ${selectedVehicleResponse.pendingAmount}`
                      : "-",
                  },
                ]
                  .filter(Boolean) // removes false/undefined items
                  .map(({ name, value }, index) => (
                    <div
                      key={index}
                      className="flex flex-col p-4 bg-white rounded-xl shadow hover:shadow-lg transition-all border border-green-100"
                    >
                      <h3 className="text-sm font-medium text-gray-500">
                        {name}
                      </h3>
                      <p
                        title={value}
                        className="text-lg font-semibold text-gray-800 mt-1 w-66 truncate"
                      >
                        {value}
                      </p>
                    </div>
                  ))}
              </div>
            )}
          </div>

          <div className="mt-8">
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
              <label>Payment Collection Type</label>
              <select
                className="w-92 h-12 p-3 border border-gray-300 rounded-md"
                value={selectedPaymentType}
                onChange={(e) => {
                  const newType = e.target.value;
                  setSelectedPaymentType(newType);
                  setPaymentTypeErrors("");

                  if (
                    (newType === "Pre Paid" || newType === "Post Paid") &&
                    selectedVehicleResponse?.pendingAmount < 0
                  ) {
                    setPaymentTypeErrors(
                      "* Cannot able to Proceed having negative amount select freeze or with refund",
                    );
                  }
                }}
              >
                <option value="">Select</option>
                {Object.entries(paymentCollectionType).map(([key, value]) => {
                  return (
                    <option key={key} value={value}>
                      {value}
                    </option>
                  );
                })}
              </select>
            </div>
            {paymentTypeErrors && (
              <p className="text-red-500 text-sm mt-1">{paymentTypeErrors}</p>
            )}
          </div>

          {selectedPaymentType === "Pre Paid" &&
            !(selectedVehicleResponse?.pendingAmount < 0) ? (
            <>
              <div className="grid grid-cols-1 md:grid-cols-4 p-2 gap-4 my-4">
                {transactionDetailsInput.map((input, index) => (
                  <div key={index}>
                    {input.type === "file" ? (
                      <>
                        <input
                          type="file"
                          accept="image/*" // or any file type
                          onChange={(e) => handleInputChange(input.value, e)}
                        />
                        {errors[input.value] && (
                          <p className="text-red-500 text-sm mt-1">
                            {errors[input.value]}
                          </p>
                        )}
                      </>
                    ) : (
                      <TextField
                        fullWidth
                        type={input.type}
                        label={input.label}
                        disabled={input?.isEnable}
                        value={transactiondetails[input.value] || ""}
                        onChange={(e) => handleInputChange(input.value, e)}
                        error={!!errors[input.value]}
                        helperText={errors[input.value]}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  </div>
                ))}
              </div>

              <div className="flex justify-end gap-4">
                <button
                  onClick={() => {
                    if (hasUnstableConnection) {
                      setPaymentLinkGenerated(false);
                      toast.error(
                        "Please check your network connection. Your internet connection appears to be unstable.",
                        {
                          position: "bottom-center",
                          style: {
                            background: "white", // override background
                            color: "red",
                            fontWeight: "medium",
                            marginBottom: "20px",
                          },
                        },
                      );
                    } else {
                      if (!paymentLinkGenerated) {
                        generatepaymentlink("generate");
                      }
                    }
                  }}
                  class={`${paymentLinkGenerated
                    ? "cursor-not-allowed opacity-50"
                    : "cursor-pointer"
                    } text-white font-bold relative text-[14px] w-[14em] h-[3em] text-center bg-gradient-to-r from-violet-500 from-10% via-sky-500 via-30% to-pink-500 to-90% bg-[length:400%] rounded-[30px] z-10 hover:animate-gradient-xy hover:bg-[length:100%] before:content-[''] before:absolute before:-top-[5px] before:-bottom-[5px] before:-left-[5px] before:-right-[5px] before:bg-gradient-to-r before:from-violet-500 before:from-10% before:via-sky-500 before:via-30% before:to-pink-500 before:bg-[length:400%] before:-z-10 before:rounded-[35px] before:hover:blur-xl before:transition-all before:ease-in-out before:duration-[1s] before:hover:bg-[length:10%] active:bg-violet-700 focus:ring-violet-700 hover:brightness-110 hover:-translate-y-[1px] active:brightness-90 active:translate-y-[2px]`}
                >
                  + Generate Payment Link
                </button>

                <button
                  onClick={handleSave}
                  disabled={
                    ![
                      "transactionid",
                      "transactioncharges",
                      "paymentmode",
                      "payableamount",
                      "paymentremarks",
                      "attachments",
                    ].every(
                      (key) =>
                        transactiondetails[key] !== null &&
                        transactiondetails[key] !== undefined &&
                        transactiondetails[key] !== "",
                    )
                  }
                  className={`relative inline-flex items-center gap-2 px-6 py-3 font-semibold text-teal-50 
                    bg-gradient-to-tr from-teal-900/50 via-teal-900/90 to-teal-900/30 ring-4 ring-teal-900/20 
                    rounded-full overflow-hidden hover:opacity-90 transition-opacity 
                    before:absolute before:top-4 before:left-1/2 before:-translate-x-1/2 
                    before:w-[100px] before:h-[100px] before:rounded-full before:bg-gradient-to-b 
                    before:from-teal-50/10 before:blur-xl
                      ${![
                      "transactionid",
                      "transactioncharges",
                      "paymentmode",
                      "payableamount",
                      "paymentremarks",
                      "attachments",
                    ].every(
                      (key) =>
                        transactiondetails[key] !== null &&
                        transactiondetails[key] !== undefined &&
                        transactiondetails[key] !== "",
                    )
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                    }`}
                >
                  + Add payment
                </button>
              </div>

              {paymentLink && (
                <div className="mt-8">
                  {/* Slow Network Warning */}
                  {hasUnstableConnection && (
                    <div className="mb-3 flex items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
                      <div className="flex h-7 w-7 items-center justify-center rounded-full bg-red-100">
                        <InfoIcon />
                      </div>

                      <div>
                        <p className="text-sm font-semibold text-red-700">
                          Slow Network
                        </p>
                        <p className="text-xs text-red-600">
                          Your network connection is not stable. Please check
                          your internet connection before proceeding.
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Payment Table */}
                  <div
                    className={`overflow-x-auto rounded-lg border shadow-lg ${hasUnstableConnection
                      ? "border-red-200 bg-red-50"
                      : "border-gray-100 bg-white"
                      }`}
                  >
                    <table className="min-w-full text-sm text-left">
                      <thead
                        className={
                          hasUnstableConnection ? "bg-red-100" : "bg-gray-50"
                        }
                      >
                        <tr>
                          <th className="whitespace-nowrap p-4 font-semibold text-gray-700">
                            Payment Id
                          </th>

                          <th className="whitespace-nowrap p-4 font-semibold text-gray-700">
                            Total Amount
                          </th>

                          <th className="whitespace-nowrap p-4 font-semibold text-gray-700">
                            Payment Url
                          </th>

                          <th className="whitespace-nowrap p-4 font-semibold text-gray-700">
                            Status
                          </th>

                          <th className="whitespace-nowrap p-4 font-semibold text-gray-700">
                            Generated At
                          </th>

                          {paymentLink?.status === "captured" ? (
                            <></>
                          ) : (
                            <th className="whitespace-nowrap p-4 text-right font-semibold text-gray-700">
                              Actions
                            </th>
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          key={paymentLink?.id}
                          className={`border-b ${hasUnstableConnection
                            ? "border-red-200 hover:bg-red-100"
                            : "border-gray-100 hover:bg-gray-50"
                            }`}
                        >
                          <td className="whitespace-nowrap p-4 text-gray-900">
                            {paymentLink?.paymentId}
                          </td>

                          <td className="whitespace-nowrap p-4 font-medium text-gray-900">
                            {"₹ " + paymentLink?.amount}
                          </td>

                          <td className="p-4">
                            <span className="block max-w-[300px] truncate text-blue-600">
                              {paymentLink?.shortUrl}
                            </span>
                          </td>

                          <td className="whitespace-nowrap p-4">
                            <span
                              className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${paymentLink?.status === "captured"
                                ? "bg-green-100 text-green-700"
                                : "bg-yellow-100 text-yellow-700"
                                }`}
                            >
                              {paymentLink?.status}
                            </span>
                          </td>

                          <td className="whitespace-nowrap p-4 text-gray-700">
                            {formatDateAndTime(paymentLink?.createdAt)}
                          </td>

                          {paymentLink?.status === "captured" ? (
                            <></>
                          ) : (
                            <td className="p-4 text-right">
                              <button
                                type="button"
                                disabled={paymentLinkGenerated}
                                onClick={() => {
                                  if (hasUnstableConnection) {
                                    setPaymentLinkGenerated(false);

                                    toast.error(
                                      "Slow Network — Your network connection is not stable. Please check your internet connection.",
                                      {
                                        position: "bottom-center",
                                        style: {
                                          background: "white",
                                          color: "red",
                                          fontWeight: "medium",
                                          marginBottom: "20px",
                                        },
                                      },
                                    );
                                  } else {
                                    if (!paymentLinkGenerated) {
                                      generatepaymentlink("actions");
                                    }
                                  }
                                }}
                                className={`inline-flex items-center justify-center rounded-md px-3 py-2 transition ${paymentLinkGenerated
                                  ? "cursor-not-allowed bg-gray-100 text-gray-400"
                                  : hasUnstableConnection
                                    ? "cursor-pointer bg-red-100 text-red-600 hover:bg-red-200"
                                    : "cursor-pointer bg-gray-100 text-gray-700 hover:bg-gray-200"
                                  }`}
                              >
                                <InfoIcon />
                              </button>
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {paymentSavedDetails && (
                <table className="min-w-full text-sm text-left shadow-lg border border-gray-100 mt-8">
                  <thead className="">
                    <tr>
                      <th className="p-4">Transaction Code</th>
                      <th className="p-4">Total Amount</th>
                      <th className="p-4">Payment Mode</th>
                      <th className="p-4">Description</th>
                      <th className="p-4">Generated At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentSavedDetails ? (
                      <tr className="border-b hover:bg-gray-50">
                        <td className="p-4">
                          {paymentSavedDetails?.transactionCode}
                        </td>
                        <td className="p-4">
                          {"₹ " + paymentSavedDetails?.amount}
                        </td>
                        <td className="p-4">
                          {paymentSavedDetails?.paymentMode}
                        </td>
                        <td className="p-4">
                          {paymentSavedDetails?.description}
                        </td>
                        <td className="p-4">
                          {formatDateAndTime(paymentSavedDetails?.createdAt)}
                        </td>
                      </tr>
                    ) : (
                      <tr>
                        <td
                          colSpan="6"
                          className="text-center p-4 text-gray-500"
                        >
                          No payment links found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              )}

              {(paymentLink?.status === "captured" || paymentSavedDetails) &&
                !loading && (
                  <div className="flex justify-end mt-6">
                    <button
                      onClick={() => {
                        if (!selectedPaymentType) {
                          setPaymentTypeErrors("* Please select payment type");
                          return;
                        }

                        const isNegativeAmount =
                          selectedVehicleResponse?.pendingAmount < 0;

                        const isAllowedForNegative =
                          selectedPaymentType === "Freeze" ||
                          selectedPaymentType === "With Refund";

                        if (isNegativeAmount && !isAllowedForNegative) {
                          setPaymentTypeErrors(
                            "* Cannot proceed with negative amount for this payment type",
                          );
                          return;
                        }

                        updateBooking();
                      }}
                      className="cursor-pointer bg-gradient-to-b from-indigo-500 to-indigo-600 shadow-[0px_4px_32px_0_rgba(99,102,241,.70)] px-6 py-3 rounded-xl border border-slate-500 text-white font-medium"
                    >
                      Update Booking
                    </button>
                  </div>
                )}
            </>
          ) : selectedVehicleResponse && !loading ? (
            <div className="flex justify-end">
              <button
                onClick={() => {
                  if (!selectedPaymentType) {
                    setPaymentTypeErrors("* Please select payment type");
                    return;
                  }

                  const isNegativeAmount =
                    selectedVehicleResponse?.pendingAmount < 0;

                  const isAllowedForNegative =
                    selectedPaymentType === "Freeze" ||
                    selectedPaymentType === "With Refund";

                  if (isNegativeAmount && !isAllowedForNegative) {
                    setPaymentTypeErrors(
                      "* Cannot proceed with negative amount for this payment type",
                    );
                    return;
                  }

                  updateBooking();
                }}
                className="cursor-pointer mt-8 bg-gradient-to-b from-indigo-500 to-indigo-600 shadow-[0px_4px_32px_0_rgba(99,102,241,.70)] px-6 py-3 rounded-xl border border-slate-500 text-white font-medium"
              >
                Update Booking
              </button>
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default Swapvehicle;
